import Icon from '@mdi/react';
import { motion, useReducedMotion } from 'framer-motion';
import { twMerge } from 'tailwind-merge';

const TextButton = ({
    icon,
    className,
    isPrimary = true,
    isSmall = false,
    isEnabled = true,
    onClick,
    children,
}: {
    icon: string;
    className?: string;
    isPrimary?: boolean;
    isSmall?: boolean;
    isEnabled?: boolean;
    onClick?: () => void;
    children: React.ReactNode | string;
}) => {
    const reduceMotion = useReducedMotion();

    return (
        <motion.div
            className="flex justify-center"
            initial={{
                scale: !reduceMotion ? 0.5 : 1,
                opacity: 0,
            }}
            animate={{
                scale: 1,
                opacity: 1,
            }}
            whileHover={
                isEnabled
                    ? {
                          scale: !reduceMotion ? 1.05 : 1,
                          opacity: 0.9,
                      }
                    : {}
            }
            whileTap={
                isEnabled
                    ? {
                          scale: !reduceMotion ? 0.95 : 1,
                          opacity: 0.8,
                      }
                    : {}
            }
        >
            <button
                onClick={onClick}
                // className={`flex items-center justify-center gap-2 rounded-full ${colorClassName} py-4 pl-8 pr-5 text-xl font-bold transition-all ease-out ${shadowClassName} ${className}`}
                className={twMerge(
                    'flex items-center justify-center gap-1.5 rounded-full font-bold transition-all ease-out',
                    isSmall
                        ? 'py-2 pl-4 pr-3 text-base'
                        : 'py-4 pl-8 pr-5 text-xl',
                    isPrimary
                        ? 'shadow-md hover:shadow-lg focus:shadow-lg active:shadow-md bg-primary-text-lg-aa text-white'
                        : 'inner-border-2 inner-border-primary-800/50 text-primary-800',
                    isEnabled ? 'opacity-100' : 'opacity-50 cursor-not-allowed',
                    className,
                )}
                disabled={!isEnabled}
            >
                {children}
                <Icon path={icon} size={1} />
            </button>
        </motion.div>
    );
};

export default TextButton;
